import setupBrowserNodeMocks from './mocks/nodejs/index.js';

const globalAny: any = typeof globalThis === 'undefined' ? undefined : (globalThis as any);

// Node 20+ exposes `globalThis.navigator` as a getter-only accessor, so any
// raw `globalThis.navigator = {...}` in downstream code (including user-written
// or AI-generated test files) throws "Cannot set property navigator of
// #<Object> which has only a getter". Re-install it as a configurable/writable
// data property once, preserving its current value, so later assignments just
// work. Browsers and environments without the accessor are left untouched.
if (
  globalAny
  && typeof process !== 'undefined'
  && !!process.versions?.node
  && !globalAny.__GOTTI_NAVIGATOR_WRITABLE__
) {
  const descriptor = Object.getOwnPropertyDescriptor(globalAny, 'navigator');
  if (descriptor && descriptor.get && !descriptor.set && descriptor.configurable) {
    const current = globalAny.navigator;
    Object.defineProperty(globalAny, 'navigator', {
      value: current,
      configurable: true,
      writable: true,
      enumerable: true,
    });
  }
  globalAny.__GOTTI_NAVIGATOR_WRITABLE__ = true;
}

if (globalAny && !globalAny.__GOTTI_TEST_UTILS_BOOTSTRAPPED__) {
  const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
  const isNodeRuntime = typeof process !== 'undefined' && !!process.versions?.node;

  if (globalAny.exports === undefined) {
    globalAny.exports = {};
  }
  if (globalAny.module === undefined) {
    globalAny.module = { exports: globalAny.exports };
  }

  const tryAssignRequire = (createRequireFn: ((path: string | URL) => NodeRequire) | undefined) => {
    if (typeof createRequireFn === 'function' && typeof globalAny.require !== 'function') {
      try {
        globalAny.require = createRequireFn(import.meta.url);
      } catch {
        /* noop */
      }
    }
  };

  if (isNodeRuntime && typeof globalAny.require !== 'function') {
    void import('node:module')
      .then(({ createRequire }) => {
        tryAssignRequire(createRequire);
      })
      .catch(() => {
        /* noop */
      });
  }

  if (isBrowser && !isNodeRuntime && !globalAny.__GOTTI_TEST_UTILS_BROWSER_READY__) {
    try {
      setupBrowserNodeMocks();
    } catch (err) {
      console.warn('[gotti][test-utils] browser mock setup failed:', err);
    }
    globalAny.__GOTTI_TEST_UTILS_BROWSER_READY__ = true;
  }

  globalAny.__GOTTI_TEST_UTILS_BOOTSTRAPPED__ = true;
}
